module.exports = __webpack_public_path__ + "static/element-1-4-x@2x-945c76580792616011cfe210a9532590.png";